<template>
  <div>
    <div class="browser-container">
      <el-row>
        <el-col :span="8"
                v-for="item in lanpack.operateList"
                :key="item.type">
          <div class="browser-item">
            <div class="title-container">
              <div class="item-title">Chrome {{item.title}}
                <span>
                  <el-tooltip class="item"
                              effect="dark"
                              :content="item.tips"
                              placement="bottom">
                    <div v-html="ToBreak(item.tips)"
                         slot="content"></div>
                    <i class="el-icon-warning-outline"
                       v-if="item.tips!==''"></i>
                  </el-tooltip>
                </span>
              </div>
            </div>

            <div class="item-icon">
              <img src="~/assets/pics/chrome_plugin.png"
                   v-if="item.type ==='BrowserPlugin'"
                   alt="" />
              <img src="~/assets/pics/chrome_fix.png"
                   v-if="item.type ==='BrowserFix'"
                   alt="" />
              <img src="~/assets/pics/chrome_reset.png"
                   v-if="item.type ==='BrowserReset'"
                   alt="" />
            </div>

            <div class="info-container">
              <div class="item-warn">
                <el-tag type="danger"
                        v-if="item.warn!==''"
                        size="medium">{{item.warn}}</el-tag>
              </div>
              <div class="item-desc">{{item.desc}}</div>
              <div class="item-details">
                {{item.details}}
              </div>
            </div>

            <div class="button-container">
              <el-tooltip class="item"
                          :disabled="item.tips===''"
                          effect="dark"
                          :content="item.tips"
                          placement="top">
                <div v-html="ToBreak(item.tips)"
                     slot="content"></div>
                <el-button type="primary"
                           class="item-button"
                           v-if="item.type === 'BrowserPlugin'"
                           :disabled="isRunning"
                           @click="handleOperate(item.type)">
                  {{lanpack.install}}
                </el-button>
                <el-button type="primary"
                           class="item-button"
                           v-else-if="item.type === 'BrowserFix'"
                           :loading="isFixing"
                           :disabled="!isFixing && isRunning"
                           @click="handleOperate(item.type)">
                  {{isFixing?lanpack.fixing:lanpack.fix}}
                </el-button>
                <el-button type="primary"
                           class="item-button"
                           v-else-if="item.type === 'BrowserReset'"
                           :loading="isReseting"
                           :disabled="!isReseting && isRunning"
                           @click="handleOperate(item.type)">
                  {{isReseting?lanpack.resetting:lanpack.reset}}
                </el-button>
              </el-tooltip>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <info-dialog :languages="languages"
                 :type="infoType"
                 :confirm="infoConfirm"
                 :btnType="btnType"
                 :show="dialogInfoVisible"
                 :tips="infoTips"
                 :submitting="submitting"></info-dialog>
    <confirm-dialog :languages="languages"
                    :type="confirmType"
                    :show="dialogConfirmVisible"></confirm-dialog>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex';
import InfoDialog from 'components/dialogs/InfoDialog.vue';
import ConfirmDialog from 'components/dialogs/ConfirmDialog.vue';
import socket from 'common/socket';
import tools from 'common/tools';
import { ubtRegister, ubtSendTrace } from '../../utils/ubt';

export default {
  inject: ['homeTemplate'],
  components: {
    InfoDialog,
    ConfirmDialog,
  },
  data () {
    return {
      isFixing: false,
      isReseting: false,
      isRunning: false,
      dialogInfoVisible: false,
      dialogConfirmVisible: false,
      infoTips: {},
      infoType: 'info',
      infoConfirm: false,
      browserFix: '',
      confirmType: '',
      btnType: 'Confirm',
      submitting: false,
      method: '',
    };
  },
  computed: {
    ...mapState([
      'languages',
      'userInfo',
      'deviceName',
      'toolList',
      'serviceVersion',
      'isNewService',
    ]),
    lanpack () {
      return this.languages.browserFix;
    },
  },
  destroyed () {
  },
  methods: {
    ...mapMutations([
      'setErrorTips',
      'setPageNow',
      'setHomeHidden',
      'setSearchHidden',
      'setShowFooter',
      'setSoftSearch',
      'handleSoftSearch',
      'setErrorType',
    ]),
    ...mapActions([
      'saveLog',
      'softwareInstall',
    ]),
    ToBreak (val) {
      return val.replace(/\n/g, '<br />');
    },
    showDialog (title, info, type = 'info', confirm = false) {
      this.infoType = type;
      this.infoConfirm = confirm;
      this.infoTips = { title, info };
      this.dialogInfoVisible = true;
    },
    hideInfoDialog () {
      this.handleReset();
      this.dialogInfoVisible = false;
    },
    installSoftware () {
      this.isRunning = true;
      switch (this.method) {
        case 'BrowserFix':
          this.isFixing = true;
          this.isReseting = false;
          break;
        case 'BrowserReset':
          this.isFixing = false;
          this.isReseting = true;
          break;
        default:
          break;
      }
      this.dialogInfoVisible = false;
      this.runTool(this.method);
      // 点击确定按钮
      ubtSendTrace(245694, 'chrome_repaire', 'click', this.method, '', 'selfhelp', this.pvId);
    },
    handleOperate (method) {
      this.method = method;
      switch (method) {
        case 'BrowserPlugin':
          this.saveLog({
            title: 'BrowserFix',
            lan: this.languages.lan,
            target: 'Go Install',
            description: 'Install Plugin',
          });
          ubtSendTrace(245694, 'chrome_repaire', 'click', method, this.lanpack.chromePlugin, '', this.pvId);
          this.$router.push('/SoftwareInstall');
          setTimeout(() => {
            this.setSoftSearch(this.lanpack.chromePlugin);
            this.handleSoftSearch(this.lanpack.chromePlugin);
          }, 500);
          break;
        case 'BrowserFix':
          this.showDialog(this.lanpack.note, this.lanpack.toFix, 'warn', 'confirm');
          ubtSendTrace(245694, 'chrome_repaire', 'click', method, '', '', this.pvId);
          break;
        case 'BrowserReset':
          this.showDialog(this.lanpack.note, this.lanpack.toReset, 'warn', 'confirm');
          ubtSendTrace(245694, 'chrome_repaire', 'click', method, '', '', this.pvId);
          break;
        default:
          break;
      }
    },
    handleReset () {
      this.isRunning = false;
      this.isFixing = false;
      this.isReseting = false;
      this.method = '';
    },
    async runTool (command) {
      const type = command === 'BrowserFix' ? this.lanpack.fix : this.lanpack.reset;
      this.browserFix = this.toolList.filter(
        (item) => item.name.indexOf('BrowserOperate') !== -1,
      );
      if (this.browserFix.length !== 1) {
        this.setErrorTips('BrowserFix > RunBrowserOperate > No such little tool');
        this.saveLog({
          title: 'api_error',
          lan: this.languages.lan,
          target: 'BrowserFix > RunBrowserOperate',
          description: 'No such little tool!',
        });
        ubtSendTrace(245694, 'chrome_repaire', 'error', 'api_error', '', '', this.pvId, 'No such little tool!');
        this.setErrorType('apierror');
        this.$router.push('/error');
        this.handleReset();
        return;
      }
      const res = await this.softwareInstall({
        account: this.userInfo.username,
        softwareId: this.browserFix[0].id,
        pcName: this.deviceName,
      });
      if (res.status === 'failed') {
        this.setErrorTips(`BrowserFix > softwareInstall > ${res.data}`);
        this.saveLog({
          title: 'api_error',
          lan: this.languages.lan,
          target: 'BrowserFix > softwareInstall',
          description: res.data,
        });
        ubtSendTrace(245694, 'chrome_repaire', 'error', 'api_error', '', '', this.pvId, res.data);
        this.setErrorType('apierror');
        this.$router.push('/error');
        this.handleReset();
        return;
      }
      const downType = this.isNewService ? 'silent' : 'littletools';
      const browserFixData = {
        lan: 'tools',
        type: downType,
        username: `${this.userInfo.username}◎${command}`,
        softid: this.browserFix[0].id,
        path: res.data.encryptPath,
        key: res.data.key,
      };
      const socketDatas = tools.toUnicode(JSON.stringify(browserFixData));
      if (this.isNewService) {
        this.homeTemplate.downToolNew('BrowserFix', this.browserFix[0].id, res, async () => {
          const runCmd = `({"level":"user", "method":"tool_run", "data":"${socketDatas}"})`;
          await socket.sendSocket(2, runCmd, async (rt) => {
            const rst = JSON.parse(rt);
            if (rst.result === 'failed') {
              this.setErrorTips(`BrowserFix > toolrun > ${rst.error}`);
              this.saveLog({
                title: 'command_error',
                target: 'runTool',
                description: rst.error,
                reserve1: 'BrowserFix > toolrun',
              });
              ubtSendTrace(245694, 'chrome_repaire', 'error', 'command_error', '', '', this.pvId, rst.error);
              this.setErrorType('apierror');
              this.$router.push('/error');
              return;
            }
            if (rst.data === 'Tool Exited') {
              const operateResult = rst.info;
              this.showResult(operateResult, type, command);
              this.handleReset();
            }
          });
        });
      } else {
        socket.sendSocket(0, `idesk_toolcheck(${socketDatas})`, (rst) => {
          console.log('toolcheck', rst);
          if (rst.result !== 'match') {
            this.setErrorTips(`BrowserFix > toolCheck > ${rst.error_msg}`);
            this.saveLog({
              title: 'toolcheck_error',
              lan: 'tools',
              target: 'BrowserFix > toolcheck',
              description: rst.error_msg,
            });
            ubtSendTrace(245694, 'chrome_repaire', 'error', 'toolcheck_error', '', '', this.pvId, rst.error_msg);
            this.setErrorType('apierror');
            this.$router.push('/error');
            this.handleReset();
            return;
          }
          socket.sendSocket(0, `idesk_toolrun(${socketDatas})`, (rt) => {
            this.handleReset();
            if (rt.result !== 'toolrun success') {
              this.setErrorTips(`BrowserFix > toolrun > ${rt.error_msg}`);
              this.saveLog({
                title: 'toolrun_error',
                lan: 'tools',
                target: 'BrowserFix > toolrun',
                description: rt.error_msg,
              });
              ubtSendTrace(245694, 'chrome_repaire', 'error', 'toolcheck_error', '', '', this.pvId, rt.error_msg);
              this.setErrorType('apierror');
              this.$router.push('/error');
              return;
            }
            const operateResult = rt.datas;
            this.showResult(operateResult, type, command);
          });
        });
      }
    },
    showResult (operateResult, type, command) {
      if (operateResult.includes('Process Exist')) {
        this.showDialog(this.lanpack.note, this.lanpack.processExist, 'warn');
        return;
      }
      if (operateResult.includes('Wrong Chrome Path')) {
        this.showDialog(this.lanpack.note, this.lanpack.wrongChrome, 'warn');
        this.saveLog({
          title: 'toolrun_error',
          lan: 'tools',
          target: 'BrowserFix > toolrun',
          description: 'Wrong Chrome Path',
        });
        ubtSendTrace(245694, 'chrome_repaire', 'error', 'toolcheck_error', '', '', this.pvId, 'Wrong Chrome Path');
        return;
      }
      if (operateResult.includes('No Directory')) {
        this.showDialog(this.lanpack.note, this.lanpack.wrongDirectory, 'warn');
        this.saveLog({
          title: 'toolrun_error',
          lan: 'tools',
          target: 'BrowserFix > toolrun',
          description: 'No Default Directory',
        });
        ubtSendTrace(245694, 'chrome_repaire', 'error', 'toolrun_error', '', '', this.pvId, 'No Default Directory');
        return;
      }
      if (operateResult.includes('Run Error')) {
        this.showDialog(this.lanpack.note, type + this.lanpack.failed, 'warn');
        this.saveLog({
          title: 'toolrun_error',
          lan: 'tools',
          target: 'BrowserFix > toolrun',
          description: 'Run Error',
        });
        ubtSendTrace(245694, 'chrome_repaire', 'error', 'toolrun_error', '', '', this.pvId, 'Run Error');
      }
      if (operateResult.includes('Run Success')) {
        this.showDialog(this.lanpack.note, type + this.lanpack.success, 'info');
        this.saveLog({
          title: 'BrowserFix',
          lan: this.languages.lan,
          target: 'Run Tool',
          description: command,
        });
        ubtSendTrace(245694, 'chrome_repaire', 'success', 'BrowserFix', '', '', this.pvId);
      }
    },
  },
  beforeDestroy () {
  },
  async created () {
    this.setErrorTips('');
    this.setPageNow('BrowserFix');
    this.setHomeHidden(false);
    this.setSearchHidden(true);
    this.setShowFooter(false);
    this.pvId = ubtRegister('Reset Browser');
  },
};
</script>

<style lang="scss" scoped>
.browser-container {
  position: absolute;
  top: 70px;
  bottom: 0;
  left: 0;
  right: 0;
  align-items: center;
}
.el-row {
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  padding: 20px 10px;
}
.browser-item {
  height: 100%;
  position: relative;
  background: #f2f7ff;
  text-align: center;
  border-radius: 10px;
  margin: 0 10px;

  .title-container {
    height: 15%;
    .item-title {
      line-height: 100px;
      span {
        position: absolute;
        white-space: pre-line;
        font-size: 18px;
        right: 20px;
        color: #ff9500;
      }
    }
  }

  .item-icon {
    padding: 20px;
    height: 20%;
  }

  .info-container {
    height: 45%;
    .item-warn {
      height: 40px;
    }
    .item-desc {
      line-height: 60px;
      font-weight: 600;
    }
    .item-details {
      white-space: pre-line;
      line-height: 30px;
      padding: 0 10px;
    }
  }
  .button-container {
    height: 10%;
    .item-button {
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      width: 130px;
    }
  }
}
</style>
